import { Attribute, Directive, Input } from '@angular/core';
import { FileLinker } from './file.linker';

@Directive({
    selector: 'a[fileLinker], button[fileLinker]',
    host: {
        '(click)': 'onClick()'
    },
    exportAs: 'fileLinker'
})
export class FileLinkerUploadDirective {

    @Input('fileLinker') 
    fileLinker: FileLinker;

    onClick() {
        if (this.fileLinker) {
            this.fileLinker.upload(null);
        } else {
            console.error('Could not find the specified fileLinker');
        }
    }
}